// Merge helpers para coleções append-only — extraído de App.jsx — Fase C
import { itemSyncTs, stripDeletedItems } from "./syncUtils";

function mergeAppendOnlyRaw(serverArr, localArr) {
  const byId = new Map();
  const pushItem = (item) => {
    if (!item || item.id == null) return;
    const id = String(item.id);
    const current = byId.get(id);
    if (!current) {
      byId.set(id, { ...item });
      return;
    }
    const currentTs = itemSyncTs(current);
    const nextTs = itemSyncTs(item);
    if (nextTs > currentTs) {
      byId.set(id, { ...current, ...item });
      return;
    }
    if (nextTs < currentTs) return;
    byId.set(id, { ...current, ...item });
  };

  (Array.isArray(serverArr) ? serverArr : []).forEach(pushItem);
  (Array.isArray(localArr) ? localArr : []).forEach(pushItem);

  return Array.from(byId.values()).sort((a, b) => {
    const an = Number(a?.id);
    const bn = Number(b?.id);
    if (Number.isFinite(an) && Number.isFinite(bn)) return an - bn;
    return String(a?.id || '').localeCompare(String(b?.id || ''));
  });
}

function mergeAppendOnlyVisible(serverArr, localArr) {
  return stripDeletedItems(mergeAppendOnlyRaw(serverArr, localArr));
}

export { mergeAppendOnlyRaw, mergeAppendOnlyVisible };
